import { render, staticRenderFns } from "./DemoDay.vue?vue&type=template&id=ceb9e424&"
import script from "./DemoDay.vue?vue&type=script&lang=js&"
export * from "./DemoDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports